import {PlacedBin} from './placed-bin';

export class Board {

    constructor(
        public w: number,
        public h: number,
        public binsGap: number
    ) {}

    public isPlacedBinInside(placedBin: PlacedBin): boolean {
        const {x, y, nextX, nextY} = placedBin;
        const {w: boardW, h: boardH, binsGap} = this;

        return x + binsGap >= 0
            && nextX - binsGap <= boardW
            && y + binsGap >= 0
            && nextY - binsGap <= boardH;
    }

    public adjustPlacedBinPos(placedBin: PlacedBin): PlacedBin {
        const {x, y, nextX, nextY} = placedBin;
        const {w: boardW, h: boardH, binsGap} = this;

        const dx: number = x + binsGap < 0
            ? -(x + binsGap)
            : nextX - binsGap > boardW
                ? boardW - (nextX - binsGap)
                : 0;
        const dy: number = y + binsGap < 0
            ? -(y + binsGap)
            : nextY - binsGap > boardH
                ? boardH - (nextY - binsGap)
                : 0;

        if (dx || dy) {
            placedBin.shiftPos(dx, dy);
        }

        return placedBin;
    }

}
